// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1590":"3638fe3a","1912":"3638fe3a","3742":"19adb09d","4762":"aa61cee9","6171":"3638fe3a","6850":"3638fe3a","6872":"08866227"}[chunkId] + ".chunk.css";
};